import { Component, computed, inject } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { MatMenuModule } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-avatar-button',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
    TranslatePipe,
  ],
  templateUrl: './avatar-button.html',
  styleUrl: './avatar-button.scss'
})
export class AvatarButton {
  public readonly initials = computed(() => this.displayName()?.split(' ').map(n => n.substring(0, 1)).join('') || '');
  public readonly displayName = computed(() => this.oktaAuthService.displayName() );

  private readonly oktaAuthService = inject(AuthService);


  logout(): void {
    this.oktaAuthService.signout();
  }

}
